import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { transparentize } from 'polished'
import { space, colors, radius } from 'theme'
import { Text } from 'components/Typography'
import Button from 'components/Button'

const ButtonLink = styled(Button.Secondary)`
  display: flex;
  text-decoration: none;
  padding: ${space.xs} ${space.s};
  margin-right: ${space.s};
  margin-top: ${space.s};
  background-color: ${({ color }) => transparentize(0.85, color)};
  text-transform: uppercase;
  border-radius: ${radius.l};
  height: fit-content;
`

const CATEGORY_COLORS = {
  'digital-marketing': colors.primary,
  'affiliate-marketing': colors.primary,
  'artificial-intelligence': colors.primary,
  'b2b-content-marketing': colors.primary,
  'content-marketing': colors.primary,
  'decentralized-social-media': colors.primary,
  sales: colors.primary,
  seo: colors.primary,
  'social-media': colors.primary,
  'tips-how-tos': colors.primary,
  trends: colors.primary,
  'social-media-management': colors.primary,

  facebook: '#6446EC',
  instagram: '#6446EC',
  linkedin: '#6446EC',
  pinterest: '#6446EC',
  twitter: '#6446EC',
  bluesky: '#6446EC',
  reddit: '#6446EC',
  threads: '#6446EC',
  tiktok: '#6446EC',
  x: '#6446EC',
  youtube: '#6446EC',

  'company-news': '#00B427',
  'case-study': '#00B427',
  'new-feature': '#00B427',
  recommendations: '#00B427',
  'success-stories': '#00B427',
  videos: '#00B427',

  automation: '#FF66C4',
  'customer-retention': '#FF66C4',
  productivity: '#FF66C4',
  reputation: '#FF66C4',

  'automotive-social-media': '#FFA43A',
  'church-social-media': '#FFA43A',
  franchise: '#FFA43A',
  'health-care-social-media-marketing': '#FFA43A',
  'real-estate': '#FFA43A',

  'employee-advocacy': '#5271FF',
  'sentiment-analysis': '#5271FF',
  'social-media-listening': '#5271FF',
  'content-repurposing': '#5271FF',
  'dm-automation': '#5271FF',

  uncategorized: colors.secondaryText,
}

const CategoryItem = ({ category, buttonStyle, ...textProps }) => {
  const { slug, name } = category

  const color = CATEGORY_COLORS[slug]

  return (
    <ButtonLink as="a" href={`/insights/${slug}`} key={slug} color={color || colors.secondaryText} style={buttonStyle}>
      <Text fontSize="xxs" color={color} fontWeight="medium" {...textProps}>
        {name}
      </Text>
    </ButtonLink>
  )
}

CategoryItem.defaultProps = {
  buttonStyle: {},
}

CategoryItem.propTypes = {
  category: PropTypes.object.isRequired,
  buttonStyle: PropTypes.object,
}

export default CategoryItem
